<script>
    export default {

    }
</script>

<template>
    <div class="info-container">
        <div class="info-item">
            <div class="img-container">
                <img src="https://flyfrontier-com-frontdoor-en-chh3dufqdpdff8h9.a02.azurefd.net/images/carry-on-icon.png" class="carry-on-img" alt="">
            </div>
            <div class="info-details">
                <div class="head">Carry On Bag</div>
                <div>10"D X 16"W  X 24"H</div>
                <div>&lt; 35 lbs</div>
            </div>
        </div>
        <div class="info-item">
            <div class="img-container">
                <img src="https://flyfrontier-com-frontdoor-en-chh3dufqdpdff8h9.a02.azurefd.net/images/checked-icon.png" class="checked-img" alt="">
            </div>
            <div class="info-details">
                <div class="head">Checked Bag</div>
                <div>62 Linear Inches</div>
                <div>&lt; 40 LBS</div>
            </div>
        </div>
        <div class="info-item">
            <div class="img-container">
                <img src="https://flyfrontier-com-frontdoor-en-chh3dufqdpdff8h9.a02.azurefd.net/images/personal-item-icon.png" class="personal-item-img" alt="">
            </div>
            <div class="info-details">
                <div class="head">Personal Item</div>
                <div>8"D X 18"W X 14"H</div>
                <div>Personal item size will be checked during boarding</div>
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";

    .info-container {
        margin-left: 24px;
        width: 357px;
        height: 288px;
        background-color: @frontier-gray-xxlighter;
        padding: 0 32px;

        .info-item {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            height: 95px;

            &:not(:first-child) {
                border-top: 1px solid @white;
            }

            .info-details {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
                color: @ibe-text--light-bluegray;
                margin-left: 26px;

                .head {
                    font-size: 16px;
                    font-weight: 600;
                    line-height: 24px;
                    color: @frontier-gray-xxdark;
                }
            }

            .img-container {
                width: 42px;    
                display: flex;
                justify-content: flex-end;

                img {
                    opacity: 0.3;

                    &.carry-on-img {
                        width: 42px;
                        height: 38px;
                    }

                    &.checked-img {
                        width: 34px;
                        height: 71px;
                    }

                    &.personal-item-img {
                        width: 32px;
                        height: 38px;
                    }
                }
            }
            
        }
        
    }
</style>